import React from 'react';
import { useTranslation } from 'react-i18next';
import './IconText/IconText.css';

type Props = {
    voteResult: boolean;
    variant?: 'icon' | 'text' | 'both';
};

const VotingResult = ({ voteResult, variant = 'both' }: Props) => {
    const { t } = useTranslation();
    const icon = voteResult ? 'check_box' : 'disabled_by_default';
    const text = voteResult ? t('accepted') : t('rejected');

    return (
        <p className={`${voteResult ? 'success' : 'error'} icon-text`}>
            {variant === 'icon' && <span className='material-symbols-rounded'>{icon}</span>}
            {variant === 'text' && text}
            {variant === 'both' && (
                <>
                    <span className='material-symbols-rounded'>{icon}</span>
                    {text}
                </>
            )}
        </p>
    );
};

export default VotingResult;
